// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_table__6sIvw {
  width: 100%;
}

.Table_table__header-cell__2394c {
  background-color: var(--sky);
  padding-block: 1.4rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}

.Table_table__header-cell__2394c:first-child {
  border-radius: 0 0.8rem 0.8rem 0;
}

.Table_table__header-cell__2394c:last-child {
  border-radius: 0.8rem 0 0 0.8rem;
}

.Table_table__row__6Qaxq:not(:last-child) > .Table_table__data-cell__MtFdy {
  border-bottom: 0.1rem solid var(--black-ten-opacity);
}

.Table_table__data-cell__MtFdy {
  padding-block: 2.5rem 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".table {\n  width: 100%;\n}\n\n.table__header-cell {\n  background-color: var(--sky);\n  padding-block: 1.4rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.table__header-cell:first-child {\n  border-radius: 0 0.8rem 0.8rem 0;\n}\n\n.table__header-cell:last-child {\n  border-radius: 0.8rem 0 0 0.8rem;\n}\n\n.table__row:not(:last-child) > .table__data-cell {\n  border-bottom: 0.1rem solid var(--black-ten-opacity);\n}\n\n.table__data-cell {\n  padding-block: 2.5rem 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `Table_table__6sIvw`,
	"table__header-cell": `Table_table__header-cell__2394c`,
	"table__row": `Table_table__row__6Qaxq`,
	"table__data-cell": `Table_table__data-cell__MtFdy`
};
export default ___CSS_LOADER_EXPORT___;
